export default __webpack_public_path__ + "static/team4-9f215cc4fd1ea25c05e53ebd844a8d7b.jpg";